<template>
  <div>
    <Header />

    <v-container
      class="mt-10"
    >
      <v-card
        :loading="isLoading"
        :disabled="isLoading"
        max-width="800"
        class="mx-auto"
      >
        <!-- Error template -->
        <template v-if="error">
          <v-card-title>
            Error
          </v-card-title>

          <v-card-text>
            <!--<div>
              {{ errorText }}
            </div>-->
            <div>
              An error occurred. <br />
              Please try again later or email
              <a href="mailto:Support@GlobalCoachGroup.com">
                Support@GlobalCoachGroup.com
              </a>for assistance.
            </div>
          </v-card-text>
        </template>

        <!-- Completed template -->
        <template v-else-if="completed">
          <v-card-title>
            Completed
          </v-card-title>

          <v-card-text>
            <div>
              An email has been sent.
              Follow the link sent by mail to reset your password.
            </div>

            <v-btn
              text
              class="mt-2 px-0"
              style="text-transform: none;"
              color="primary"
              @click="$router.push({ name: 'login' })"
            >
              Go back to login page
            </v-btn>
          </v-card-text>
        </template>

        <!-- Working template -->
        <template v-else>
          <v-card-title>
            Forgot Password
          </v-card-title>

          <v-card-text>
            <div class="mb-5">
              A confirmation link will be sent to your email address.
              Please click on the link to set up a new password.
            </div>

            <v-form
              ref="form"
              @submit.prevent="submit"
            >
              <v-text-field
                v-model="email"
                label="Email address"
                :rules="rules.email"
              />
            </v-form>
          </v-card-text>

          <v-card-actions
            class="justify-end"
          >
            <v-btn
              color="#003865"
              dark
              @click="submit"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import accountApi from '@/api/account/account';
import Header from '@/views/components/Header.vue';

export default {
  name: 'ForgotMyPassword',

  components: {
    Header,
  },

  data: () => ({
    error: false,
    errorText: 'An error occurred during progress. Please try again later.',
    completed: false,
    isLoading: false,
    email: null,
    rules: {
      email: [
        (v) => !!v || 'Email is required',
        (v) => /\S+@\S+\.\S+/.test(v) || 'Email is not valid',
      ],
    },
  }),

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          this.isLoading = true;
          const param = { email: this.email };
          await accountApi.requestPasswordReset(param);
          this.completed = true;
        } catch (err) {
          this.error = true;
          if (err.msg) {
            this.errorText = err.msg;
          }
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
